<template>
    <div class="navbar__label" :class="{'navbar__label--visible': isVisible}">
        {{ label }}
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        label: string;
        isVisible: boolean;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .navbar__label {
        @include text.getFontBySize(primary-650);

        position: absolute;
        left: var(--joy-core-spacing-9);
        bottom: 18px;
        text-align: center;
        color: var(--joy-color-neutral-70);
        opacity: 0;
        pointer-events: none;
        transition: opacity calc(var(--navbar-transition-duration) * 0.4) var(--navbar-transition-easing);

        &--visible {
            opacity: 1;
            transition-delay: calc(var(--navbar-transition-duration) * 0.6);
        }
    }

    @include mq.screen_md(min) {
        .navbar__label {
            display: none;
        }
    }
</style>
